import { useState } from 'react';

const ALLOWED_USERS = [
  { username: 'admin', password: 'aAsSDHAusua!@9301@sa' },
  { username: 'tester', password: 'test1234' },
  { username: 'public', password: 'Public@1234' },
];

export default function StagingLogin({ onAuthenticated }) {
  const [inputUser, setInputUser] = useState('');
  const [inputPass, setInputPass] = useState('');
  const [error, setError] = useState('');
  const isStaging =
    window.location.hostname.includes('staging') ||
    window.location.hostname.includes('localhost');

  const handleLogin = () => {
    const user = ALLOWED_USERS.find(
      (u) => u.username === inputUser && u.password === inputPass
    );
    if (user) {
      sessionStorage.setItem('staging_auth', 'true');
      onAuthenticated();
    } else {
      setError('Invalid credentials');
    }
  };

  if (!isStaging) return null;

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded shadow-md w-80">
        <h2 className="text-xl font-bold mb-4 text-center">Staging Login</h2>
        <input
          type="text"
          placeholder="Username"
          value={inputUser}
          onChange={(e) => setInputUser(e.target.value)}
          className="w-full mb-2 px-3 py-2 border rounded"
        />
        <input
          type="password"
          placeholder="Password"
          value={inputPass}
          onChange={(e) => setInputPass(e.target.value)}
          className="w-full mb-3 px-3 py-2 border rounded"
        />
        {error && <div className="text-red-500 text-sm mb-2">{error}</div>}
        <button
          onClick={handleLogin}
          className="w-full bg-purple-600 text-white py-2 rounded hover:bg-purple-700"
        >
          Login
        </button>
      </div>
    </div>
  );
}